import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.admin');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU, getAdminLang, setAdminLang, getAdminT } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-component-nav-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.admin/view.scss */
:host {
  display: block;
}`],
})
export class ComponentNavAdminComponent implements OnInit {
    public ru = RU;
    public t: any = RU;
    public lang: string = 'ru';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.lang = getAdminLang();
        this.t = getAdminT();
    }

    public async toggleLang() {
        this.lang = this.lang === 'ru' ? 'ko' : 'ru';
        setAdminLang(this.lang);
        this.t = getAdminT();
        await this.service.render();
        // 다른 admin 페이지에도 언어 변경을 알림
        window.dispatchEvent(new CustomEvent('admin-lang-change', { detail: this.lang }));
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0;
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return 'group flex gap-x-2 items-center rounded-md bg-emerald-50 px-2 py-1.5 text-[13px] font-medium text-emerald-700';
        }
        return 'group flex gap-x-2 items-center rounded-md px-2 py-1.5 text-[13px] font-medium text-gray-600 hover:bg-gray-50 hover:text-emerald-600';
    }
}

export default ComponentNavAdminComponent;